import { PowerDialerRoutes } from './type'

const powerDialer = `${PowerDialerRoutes.root}`

export const PowerDialerPath = {
  root: powerDialer,
}
